
export const CgnTaxNoControl = new RegExp(
    /^([0-9]{10,11})$/i
  );